import { combineReducers } from 'redux'
import {
  COMPLAINT_GET_LOADING,
  COMPLAINT_GET_ERROR,
  COMPLAINT_GET_SUCCESS,

  COMPLAINT_VIEW_ERROR,
  COMPLAINT_VIEW_LOADING,
  COMPLAINT_VIEW_SUCCESS,

  COMPLAINT_ADD_ERROR,
  COMPLAINT_ADD_LOADING,
  COMPLAINT_ADD_SUCCESS,

  COMPLAINT_DELETE_ERROR,
  COMPLAINT_DELETE_LOADING,
  COMPLAINT_DELETE_SUCCESS,

  COMPLAINT_REPLY_ERROR,
  COMPLAINT_REPLY_LOADING,
  COMPLAINT_REPLY_SUCCESS,

  COMPLAINT_CLOSE_ERROR,
  COMPLAINT_CLOSE_LOADING,
  COMPLAINT_CLOSE_SUCCESS,

  COMPLAINT_EKSKALASI_ERROR,
  COMPLAINT_EKSKALASI_LOADING,
  COMPLAINT_EKSKALASI_SUCCESS,

  COMPLAINT_USER_TYPE_ERROR,
  COMPLAINT_USER_TYPE_LOADING,
  COMPLAINT_USER_TYPE_SUCCESS,

  COMPLAINT_USER_EKSKALASI_ERROR,
  COMPLAINT_USER_EKSKALASI_LOADING,
  COMPLAINT_USER_EKSKALASI_SUCCESS,

  COMPLAINT_CATEGORIES_ERROR,
  COMPLAINT_CATEGORIES_LOADING,
  COMPLAINT_CATEGORIES_SUCCESS,
} from '../actions/constant'

const complaintGetError = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_GET_ERROR:
      return action.complaintGetError
    default:
      return state
  }
}

const complaintGetLoading = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_GET_LOADING:
      return action.complaintGetLoading
    default:
      return state
  }
}

const complaintGetSuccess = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_GET_SUCCESS:
      return action.complaintGetSuccess
    default:
      return state
  }
}

const complaints = (state = [], action) => {
  switch (action.type) {
    case COMPLAINT_GET_SUCCESS:
      return action.complaints
    default:
      return state
  }
}

const complaintViewLoading = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_VIEW_LOADING:
      return action.complaintViewLoading
    default:
      return state
  }
}

const complaintViewError = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_VIEW_ERROR:
      return action.complaintViewError
    default:
      return state
  }
}

const complaintViewSuccess = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_VIEW_SUCCESS:
      return action.complaintViewSuccess
    default:
      return state
  }
}

const complaint = (state=[], action) => {
  switch (action.type) {
    case COMPLAINT_VIEW_SUCCESS:
      return action.complaint
    default:
      return state
  }
}

const complaintAddError = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_ADD_ERROR:
      return action.complaintAddError
    default:
      return state
  }
}

const complaintAddLoading = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_ADD_LOADING:
      return action.complaintAddLoading
    default:
      return state
  }
}

const complaintAddSuccess = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_ADD_SUCCESS:
      return action.complaintAddSuccess
    default:
      return state
  }
}

const complaintAddResult = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_ADD_SUCCESS:
      return action.result
    default:
      return state
  }
}

const complaintDeleteError = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_DELETE_ERROR:
      return action.complaintDeleteError
    default:
      return state
  }
}

const complaintDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_DELETE_LOADING:
      return action.complaintDeleteLoading
    default:
      return state
  }
}

const complaintDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_DELETE_SUCCESS:
      return action.complaintDeleteSuccess
    default:
      return state
  }
}

const complaintReplyError = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_REPLY_ERROR:
      return action.complaintReplyError
    default:
      return state
  }
}

const complaintReplyLoading = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_REPLY_LOADING:
      return action.complaintReplyLoading
    default:
      return state
  }
}

const complaintReplySuccess = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_REPLY_SUCCESS:
      return action.complaintReplySuccess
    default:
      return state
  }
}

const complaintCloseError = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_CLOSE_ERROR:
      return action.complaintCloseError
    default:
      return state
  }
}

const complaintCloseLoading = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_CLOSE_LOADING:
      return action.complaintCloseLoading
    default:
      return state
  }
}

const complaintCloseSuccess = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_CLOSE_SUCCESS:
      return action.complaintCloseSuccess
    default:
      return state
  }
}

const complaintEkskalasiError = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_EKSKALASI_ERROR:
      return action.complaintEkskalasiError
    default:
      return state
  }
}

const complaintEkskalasiLoading = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_EKSKALASI_LOADING:
      return action.complaintEkskalasiLoading
    default:
      return state
  }
}

const complaintEkskalasiSuccess = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_EKSKALASI_SUCCESS:
      return action.complaintEkskalasiSuccess
    default:
      return state
  }
}

const complaintUserTypeError = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_USER_TYPE_ERROR:
      return action.complaintUserTypeError
    default:
      return state
  }
}

const complaintUserTypeLoading = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_USER_TYPE_LOADING:
      return action.complaintUserTypeLoading
    default:
      return state
  }
}

const complaintUserTypeSuccess = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_USER_TYPE_SUCCESS:
      return action.complaintUserTypeSuccess
    default:
      return state
  }
}

const complaintUserTypes = (state = [], action) => {
  switch (action.type) {
    case COMPLAINT_USER_TYPE_SUCCESS:
      return action.userTypes
    default:
      return state
  }
}

const complaintUserEkskalasiError = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_USER_EKSKALASI_ERROR:
      return action.complaintUserEkskalasiError
    default:
      return state
  }
}

const complaintUserEkskalasiLoading = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_USER_EKSKALASI_LOADING:
      return action.complaintUserEkskalasiLoading
    default:
      return state
  }
}

const complaintUserEkskalasiSuccess = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_USER_EKSKALASI_SUCCESS:
      return action.complaintUserEkskalasiSuccess
    default:
      return state
  }
}

const complaintUserEkskalasi = (state = [], action) => {
  switch (action.type) {
    case COMPLAINT_USER_EKSKALASI_SUCCESS:
      return action.userEkskalasi
    default:
      return state
  }
}

const complaintCategoriesError = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_CATEGORIES_ERROR:
      return action.complaintCategoriesError
    default:
      return state
  }
}

const complaintCategoriesLoading = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_CATEGORIES_LOADING:
      return action.complaintCategoriesLoading
    default:
      return state
  }
}

const complaintCategoriesSuccess = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_CATEGORIES_SUCCESS:
      return action.complaintCategoriesSuccess
    default:
      return state
  }
}

const complaintCategories = (state = [], action) => {
  switch (action.type) {
    case COMPLAINT_CATEGORIES_SUCCESS:
      return action.categories
    default:
      return state
  }
}

const complaintReducer = combineReducers({
  complaintGetError,
  complaintGetLoading,
  complaintGetSuccess,
  complaints,

  complaintViewLoading,
  complaintViewError,
  complaintViewSuccess,
  complaint,

  complaintAddError,
  complaintAddLoading,
  complaintAddSuccess,
  complaintAddResult,

  complaintDeleteError,
  complaintDeleteLoading,
  complaintDeleteSuccess,

  complaintReplyError,
  complaintReplyLoading,
  complaintReplySuccess,

  complaintCloseError,
  complaintCloseLoading,
  complaintCloseSuccess,

  complaintEkskalasiError,
  complaintEkskalasiLoading,
  complaintEkskalasiSuccess,

  complaintUserTypeError,
  complaintUserTypeLoading,
  complaintUserTypeSuccess,
  complaintUserTypes,

  complaintUserEkskalasiError,
  complaintUserEkskalasiLoading,
  complaintUserEkskalasiSuccess,
  complaintUserEkskalasi,
  
  complaintCategoriesError,
  complaintCategoriesLoading,
  complaintCategoriesSuccess,
  complaintCategories
})

export default complaintReducer
